export default "__VITE_ASSET__BljiAZRr__"